import { faFaceViewfinder } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { UserContentReviewList } from '../organisms/UserContentReviewList';

export type IAppUserContentReviewsPageProps = {
  appId: string;
};

export const AppUserContentReviewsPage: React.FC<
  IAppUserContentReviewsPageProps
> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppUserContentReviewsPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faFaceViewfinder} />}
        title={t('AppUserContentReviewsPage.title')}
        subtitle={t('AppUserContentReviewsPage.subtitle')}
      />

      <UserContentReviewList appId={appId} />
    </>
  );
};
